import React from 'react';
import { Section, SectionHeader } from '../ui/Section';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Aprende de los grandes genios de la historia', 'Desarrolla pensamiento crítico', 'Inspira tu mente', 'Ideal para estudiar o escuchar', 'Educación profunda y accesible', 'Contenido curado por expertos'];
export function BenefitsSection() {
  return <Section background="brown" className="relative overflow-hidden" data-id="element-15">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#C9A227] rounded-full blur-[150px] opacity-10 pointer-events-none" data-id="element-16"></div>

      <div className="max-w-3xl mx-auto" data-id="element-17">
        <SectionHeader title="Beneficios Transformadores" subtitle="Más que información, una nueva forma de ver el mundo." centered={true} light={true} data-id="element-18" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-19">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start" data-id="element-20">
              <CheckCircle2 className="w-6 h-6 text-[#C9A227] mt-1 mr-4 flex-shrink-0" data-id="element-21" />
              <span className="text-lg text-[#E0D8D0] font-light" data-id="element-22">
                {benefit}
              </span>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}